import styled from 'styled-components';
import { Docs } from '@splytech-io/router';
import { PageSections } from '../Components/PageSections';

export function FreeformPage(props: {
  page: Docs.Page;
  variables?: Record<string, string>;
}) {
  return (
    <Section className="px-3">
      <h2>{props.page.title}</h2>
      <PageSections items={props.page.sections} variables={props.variables}/>
    </Section>
  );
}

const Section = styled.section`
  padding-bottom: 10% !important;
`;
